import { motion } from 'framer-motion';
import styled from 'styled-components/macro';
import StyledFlexContainer from './StyledFlexContainer';

const MotionStyledFlexContainer = styled(motion(StyledFlexContainer))`
	justify-content: center;
	align-items: center;
`;

export default MotionStyledFlexContainer;
